import { uniqBy, filter, indexOf, map } from 'lodash';

import * as ActionTypes from '../components/actions/types';

const initialState = [];

function cmsEventParticipantReducer(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.FETCH_CMS_EVENT_PARTICIPANT:
      return action.payload;
    case ActionTypes.ACCEPT_CMS_EVENT_CANDIDATE: {
      return [...state, action.payload];
    }
    case ActionTypes.REJECT_CMS_EVENT_CANDIDATE: {
      return filter(state, p => p.id !== action.payload);
    }
    case ActionTypes.ADD_CMS_EVENT_PARTICIPANT: {
      return uniqBy([...state, ...action.payload], 'email');
    }
    case ActionTypes.REMOVE_CMS_EVENT_PARTICIPANT:
      return filter(
        state,
        participant => indexOf(action.payload, participant.email) === -1,
      );
    case ActionTypes.APPEND_PARTICIPANTS:
      return uniqBy([...state, ...action.payload], 'email');
    case ActionTypes.CHANGE_PARTICIPANT_ADMISSION_STATUS:
      return map(state, p => (
        (p.email === action.payload.email) ? { ...p, ...action.payload } : p
      ));
    default:
      return state;
  }
}

export default cmsEventParticipantReducer;



// WEBPACK FOOTER //
// ./src/reducers/cmsEventParticipant.js